import Vue from 'vue'

import App from './App.vue'
import router from './router/index.js'
import store from "./store/index.js";
import VueWechatTitle from 'vue-wechat-title'
import {
	VueJsonp
} from 'vue-jsonp'
import './common'
import 'lib-flexible/flexible.js'
Vue.use(VueJsonp)
Vue.use(VueWechatTitle)
Vue.config.productionTip = false

import {
	getOpenId,
} from '@/request/api';
var getCodeFun = function () {
	// let payBack = "https://atest.xty86.com/";
	let payBack = window.location.href;
	// 正式环境
	let appId = "wx3de49bcab72a4020"
	// 测试环境公众号ID
	// let appId = "wxeade3e34841010b2"
	let codeUri = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" +
		encodeURIComponent(payBack) + "&response_type=code&scope=snsapi_base#wechat_redirect"
	window.location.href = codeUri
}

window._AMapSecurityConfig = {
	// securityJsCode:"0df2b516e9a3171317210cf56fec4eb3" //华瑞
	// securityJsCode:"cfee88c097ca0db8509ddfeaefcfdfbb" // 我的
	// securityJsCode:"aa59a7acf2b6b171e8307eae2dde168b" // 悦动
	securityJsCode:"a196af9df442528fff6391f93d52786d" // 第三方
  }

var getUrlParam = function (name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
	let url = window.location.href.split('#')[0]
	let search = url.split('?')[1]
	if (search) {
		var r = search.substr(0).match(reg)
		if (r !== null) return unescape(r[2])
		return null
	} else {
		return null
	}
}
var isWechat = function () {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return 0
	} else {
		return 1
	}
}
Vue.prototype.$getUrlParam = getUrlParam
var browserFlag = isWechat();
let code = getUrlParam("code")
if (browserFlag == 0 && code) {
	if (code && (localStorage.getItem('openId') == "" || localStorage.getItem('openId') == null || localStorage.getItem(
		'openId') == undefined)) {
		getOpenId({
			code: code
		}).then(res => {
			if (res) {
				localStorage.setItem('openId', res)
			}
		})
	}
} else if (browserFlag == 0 && !code) {
	getCodeFun();
}
// if(browserFlag == 0 && localStorage.getItem('openId')){
// 	getCodeFun();
// }




// 防抖处理-立即执行
const on = Vue.prototype.$on
Vue.prototype.$on = function (event, func) {
	let timer;
	let flag = true;
	let newFunc = func
	if (event == 'click') {
		newFunc = function () {
			if (flag) {
				func.apply(this, arguments)
				flag = false
			}
			clearTimeout(timer)
			timer = setTimeout(function () {
				flag = true
			}, 500)
		}
	}
	on.call(this, event, newFunc)
}
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
